class EnterVirtualDataService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Get both the form metadata and previously saved form data for the given
     * client/facility/month/year combination.
     *
     * @param clientId      the client whose form metadata should be returned.
     * @param facilityId    the ID of the facility whose data will be updated.
     * @param month         the month of data that will be updated.
     * @param year          the year of the data that will be updated.
     *
     * @returns {Promise}
     */
    getForm(clientId, countryId, campusId, facilityId, month, year) {
        const config = {
            params: {
                client: clientId,
                country: countryId,
                campus: campusId,
                facility: facilityId,
                month: month,
                year: year
            }
        };
        return this.$http.get(`${this.appConfig.apiUrl}/forms/virtual-data-entry/`, config);
    }

    getChangeReasons() {
        return this.$http.get(`${this.appConfig.apiUrl}/stats/change-reasons/`).then((successResponse) => {
            return successResponse.data;
        })
    }

}

export default EnterVirtualDataService;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data-service.js